import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import '@fontsource-variable/figtree';
import '@fontsource-variable/jetbrains-mono';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ConfirmProvider } from './ui/ConfirmDialog';
import { applyDensity, applyTheme, loadDensity, loadTheme, watchSystemTheme } from './ui/theme';
import { ToastProvider } from './ui/Toast';
import './styles.css';

applyTheme(loadTheme()); // before the first paint (index.html did the same without the module)
applyDensity(loadDensity());
watchSystemTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider baseUrl={import.meta.env.VITE_API_BASE ?? ''}>
      <ToastProvider>
        <ConfirmProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfirmProvider>
      </ToastProvider>
    </AuthProvider>
  </StrictMode>,
);
